import { cardSrc } from './resultParsers';

// 20-20 D T L result — card = [Dragon, Tiger, Lion]; rdesc = "<Winner>#<Red/Black>#
// <Odd/Even>#<Card>". Winner sid: Dragon=1, Tiger=21, Lion=41 (winnat bhi milta hai).
const SIDES = [
  { key: 'D', label: 'Dragon' },
  { key: 'T', label: 'Tiger' },
  { key: 'L', label: 'Lion' },
];

export default function DTL20Result({ detail }) {
  const codes = String(detail?.card || '').split(',').map((s) => s.trim());
  const parts = String(detail?.rdesc || '').split('#');
  const winner = detail?.winnat || parts[0] || '';
  const redBlack = parts[1] || '';
  const oddEven = parts[2] || '';
  const cardDesc = parts[3] || '';

  return (
    <div className="row row5 dtl20-result text-center">
      {SIDES.map((s, i) => {
        const isWinner = winner === s.label;
        return (
          <div key={s.key} className="col-12 col-lg-2">
            <div className="casino-result-cards">
              {isWinner && (
                <div className="casino-result-cards-item">
                  <img src="https://wver.sprintstaticdata.com/v230/static/front/img/winner.png" className="winner-icon" alt="Winner" />
                </div>
              )}
              {' '}
              <div className="d-inline-block">
                <h4>{s.label}</h4>
                {codes[i] && codes[i] !== '1' && (
                  <>
                    {' '}
                    <div className="casino-result-cards-item">
                      <img src={cardSrc(codes[i])} alt={codes[i]} />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        );
      })}
      <div className="col-12 col-lg-6">
        <div className="casino-result-desc">
          <div className="casino-result-desc-item">
            <div>Winner</div>
            <div>{winner || '-'}</div>
          </div>
          {redBlack && (
            <div className="casino-result-desc-item">
              <div>Red/Black</div>
              <div>{redBlack}</div>
            </div>
          )}
          {oddEven && (
            <div className="casino-result-desc-item">
              <div>Odd/Even</div>
              <div>{oddEven}</div>
            </div>
          )}
          {cardDesc && (
            <div className="casino-result-desc-item">
              <div>Card</div>
              <div>{cardDesc}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
